var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHow3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "150px",
    height: "132px",
    viewBox: "0 0 150 132",
    enableBackground: "new 0 0 150 132",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "#F8E7E7",
    cx: 116.736,
    cy: 23.787,
    r: 23.37
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#F8E7E7",
    d: "M4.557,80.182c0.213,0.379,0.432,0.754,0.658,1.121h58.781c0.226-0.367,0.445-0.742,0.658-1.121H4.557z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F8E7E7",
    d: "M8.089,85.315c0.316,0.381,0.64,0.754,0.972,1.121H60.15c0.332-0.367,0.656-0.74,0.972-1.121H8.089z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F8E7E7",
    d: "M6.152,82.749c0.26,0.379,0.525,0.754,0.8,1.121h55.307c0.274-0.367,0.54-0.742,0.799-1.121H6.152z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F8E7E7",
    d: "M1.386,72.485c0.104,0.376,0.212,0.75,0.328,1.121h65.785c0.116-0.371,0.224-0.745,0.328-1.121H1.386z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F8E7E7",
    d: "M2.201,75.051c0.137,0.377,0.281,0.75,0.43,1.121H66.58c0.149-0.371,0.293-0.744,0.43-1.121H2.201z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F8E7E7",
    d: "M3.251,77.616c0.172,0.379,0.352,0.752,0.538,1.123h61.633c0.186-0.371,0.366-0.744,0.539-1.123H3.251z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F8E7E7",
    d: "M10.45,87.881c0.389,0.383,0.788,0.756,1.195,1.121h45.92c0.408-0.365,0.806-0.738,1.196-1.121H10.45z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F8E7E7",
    d: "M22.497,95.579c1.16,0.436,2.348,0.812,3.563,1.121h17.09c1.215-0.309,2.404-0.686,3.563-1.121H22.497z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F8E7E7",
    d: "M0.149,63.313c0,0.01,0,0.02,0,0.029h68.913c0-0.01,0-0.02,0-0.029c0-0.366-0.007-0.73-0.019-1.093H0.168 C0.157,62.583,0.149,62.947,0.149,63.313z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F8E7E7",
    d: "M43.375,29.984c-2.8-0.735-5.738-1.127-8.769-1.127c-3.03,0-5.969,0.393-8.769,1.127H43.375z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F8E7E7",
    d: "M13.368,90.448c0.495,0.387,1.001,0.76,1.517,1.121h39.442c0.516-0.361,1.022-0.734,1.517-1.121H13.368z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F8E7E7",
    d: "M17.131,93.012c0.672,0.396,1.359,0.771,2.059,1.123h30.83c0.701-0.352,1.387-0.727,2.059-1.123H17.131z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F8E7E7",
    d: "M0.784,69.919c0.073,0.376,0.15,0.75,0.235,1.121h67.172c0.085-0.371,0.163-0.745,0.235-1.121H0.784z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F8E7E7",
    d: "M10.067,39.126c-0.361,0.366-0.714,0.74-1.059,1.122h51.193c-0.344-0.382-0.697-0.755-1.058-1.122H10.067z "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F8E7E7",
    d: "M4.344,46.825c-0.202,0.369-0.396,0.744-0.584,1.121h61.691c-0.188-0.377-0.382-0.752-0.583-1.121H4.344z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F8E7E7",
    d: "M5.895,44.259c-0.246,0.369-0.485,0.742-0.716,1.121h58.854c-0.231-0.379-0.471-0.752-0.716-1.121H5.895z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F8E7E7",
    d: "M0.386,67.353c0.043,0.376,0.092,0.75,0.148,1.122h68.143c0.056-0.372,0.104-0.746,0.148-1.122H0.386z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F8E7E7",
    d: "M7.778,41.692c-0.297,0.368-0.587,0.741-0.869,1.122h55.393c-0.282-0.38-0.572-0.753-0.869-1.122H7.778z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F8E7E7",
    d: "M21.526,31.428c-0.835,0.343-1.653,0.717-2.454,1.122h31.066c-0.8-0.405-1.619-0.779-2.453-1.122H21.526z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F8E7E7",
    d: "M16.499,33.994c-0.578,0.358-1.145,0.731-1.699,1.122h39.611c-0.554-0.39-1.121-0.764-1.699-1.122H16.499z "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F8E7E7",
    d: "M12.892,36.561c-0.447,0.363-0.884,0.737-1.312,1.122h46.052c-0.428-0.385-0.866-0.759-1.312-1.122H12.892 z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F8E7E7",
    d: "M0.711,57.089c-0.068,0.372-0.13,0.746-0.186,1.121h68.16c-0.056-0.375-0.118-0.75-0.186-1.121H0.711z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F8E7E7",
    d: "M0.342,59.655c-0.039,0.371-0.073,0.745-0.1,1.121h68.727c-0.027-0.376-0.061-0.75-0.1-1.121H0.342z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F8E7E7",
    d: "M3.08,49.391c-0.164,0.371-0.322,0.744-0.473,1.122h63.997c-0.151-0.377-0.309-0.751-0.473-1.122H3.08z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F8E7E7",
    d: "M0.183,64.786c0.016,0.376,0.036,0.75,0.063,1.122h68.719c0.028-0.372,0.047-0.746,0.063-1.122H0.183z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F8E7E7",
    d: "M1.282,54.523c-0.098,0.371-0.19,0.745-0.275,1.121h67.198c-0.086-0.376-0.178-0.75-0.276-1.121H1.282z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F8E7E7",
    d: "M2.067,51.957c-0.129,0.372-0.255,0.745-0.372,1.122h65.822c-0.117-0.377-0.243-0.75-0.373-1.122H2.067z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#06065C",
    d: "M115.094,50.986c0,5.545-1.086,10.925-3.228,15.989c-2.069,4.891-5.031,9.285-8.803,13.056 c-3.773,3.771-8.166,6.734-13.057,8.803c-5.064,2.143-10.444,3.229-15.99,3.229s-10.925-1.086-15.989-3.229 c-4.892-2.068-9.285-5.031-13.057-8.803s-6.734-8.166-8.803-13.056c-2.142-5.064-3.228-10.444-3.228-15.989 c0-5.545,1.086-10.925,3.228-15.989c2.069-4.892,5.031-9.284,8.803-13.057s8.166-6.734,13.057-8.803 c5.064-2.142,10.443-3.228,15.989-3.228s10.925,1.086,15.99,3.228c4.891,2.069,9.283,5.031,13.057,8.803 c3.771,3.772,6.733,8.165,8.803,13.057C114.008,40.061,115.094,45.441,115.094,50.986z M33.2,50.986 c0,22.506,18.311,40.817,40.817,40.817c22.507,0,40.818-18.311,40.818-40.817c0-22.507-18.311-40.817-40.818-40.817 C51.51,10.169,33.2,28.479,33.2,50.986z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EAAC50",
    d: "M33.916,26.793c0.874,0.436,1.88,0.922,2.989,1.448c1.019,0.484,2.124,1,3.294,1.541 c12.34,5.703,31.808,14.062,31.808,14.062L56.159,12.888l-1.657-3.236L52.99,6.697C44.565,11.018,37.803,18.121,33.916,26.793z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EAAC50",
    d: "M75.639,5.702c23.043,0,41.724,18.68,41.724,41.724c0,23.043-18.681,41.723-41.724,41.723 s-41.723-18.68-41.723-41.723c0-6.074,1.298-11.845,3.632-17.05c0.874,0.435,1.88,0.922,2.989,1.448 c-2.123,4.767-3.302,10.047-3.302,15.602c0,14.228,8.364,24.551,19.861,31.186c5.642,3.256,11.562,7.219,18.543,7.219 c10.817,0,18.938-5.922,25.919-13.119c6.706-6.914,12.484-14.894,12.484-25.286c0-12.877-7.184-21.902-16.91-28.869 c-6.294-4.509-13.16-9.536-21.493-9.536c-6.305,0-12.256,1.52-17.504,4.213l-1.513-2.955C62.324,7.353,68.789,5.702,75.639,5.702 z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E54750",
    d: "M36.905,28.241c1.019,0.484,2.124,1,3.294,1.541c12.34,5.703,31.808,14.062,31.808,14.062L56.159,12.888 l-1.657-3.236C46.718,13.644,40.476,20.217,36.905,28.241z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E54750",
    d: "M75.639,9.021c8.333,0,15.199,5.026,21.493,9.536c9.727,6.967,16.91,15.992,16.91,28.869 c0,10.393-5.778,18.372-12.484,25.286c-6.98,7.197-15.102,13.119-25.919,13.119c-6.982,0-12.902-3.963-18.543-7.219 c-11.497-6.635-19.861-16.958-19.861-31.186c0-5.555,1.179-10.835,3.302-15.602c1.019,0.483,2.125,1,3.294,1.54 c-1.904,4.299-2.961,9.057-2.961,14.062c0,19.202,15.567,34.768,34.77,34.768c19.202,0,34.769-15.566,34.769-34.768 c0-19.203-15.566-34.77-34.769-34.77c-5.708,0-11.096,1.375-15.848,3.814l-1.656-3.236C63.383,10.541,69.333,9.021,75.639,9.021z "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EAAC50",
    d: "M75.639,12.656c19.202,0,34.769,15.567,34.769,34.77c0,19.202-15.566,34.768-34.769,34.768 c-19.203,0-34.77-15.566-34.77-34.768c0-5.005,1.058-9.763,2.961-14.062c12.34,5.703,31.808,14.062,31.808,14.062L59.791,16.47 C64.543,14.032,69.93,12.656,75.639,12.656z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EAAC50",
    d: "M56.159,12.888l15.848,30.956c0,0-19.468-8.358-31.808-14.062C43.427,22.488,49.091,16.513,56.159,12.888 z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#70C6B7",
    d: "M67.726,21.668l-0.4-0.323c0.043-0.053,1.083-1.319,3.729-2.359c2.412-0.949,6.689-1.882,13.366-0.938 l-0.072,0.509c-6.535-0.923-10.709-0.025-13.061,0.89C68.749,20.436,67.736,21.656,67.726,21.668z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#70C6B7",
    d: "M82.509,18.079c0,0-0.469,7.557-7.66,7.191C74.849,25.27,75.263,20.516,82.509,18.079z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#70C6B7",
    d: "M77.931,17.908c0,0-5.069-0.855-6.249-5.029C71.682,12.879,76.112,12.729,77.931,17.908z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#70C6B7",
    d: "M72.007,18.917c0,0,2.131,4.329-3.085,7.331C68.922,26.248,67.439,22.447,72.007,18.917z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#06065C",
    d: "M81.846,18.376l-0.007,0.116c-0.002,0.019-0.131,1.928-1.144,3.766 c-0.597,1.082-1.378,1.929-2.323,2.518c-1.181,0.735-2.619,1.065-4.276,0.981l-0.081-0.004l0.007-0.081 c0.004-0.049,0.117-1.226,1.126-2.719c0.928-1.372,2.823-3.274,6.587-4.54L81.846,18.376z M74.188,25.604 c2.904,0.124,5.047-1.026,6.367-3.417c0.855-1.548,1.071-3.148,1.117-3.587c-3.643,1.25-5.484,3.096-6.389,4.432 C74.441,24.274,74.233,25.314,74.188,25.604z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#06065C",
    d: "M76.931,19.016L76.8,18.994c-0.012-0.002-1.295-0.225-2.704-0.958 c-1.305-0.678-2.989-1.945-3.605-4.127l-0.027-0.096l0.1-0.003c0.046-0.001,1.141-0.031,2.478,0.58 c1.231,0.562,2.898,1.8,3.847,4.502L76.931,19.016z M70.669,13.966c0.625,2.068,2.242,3.278,3.498,3.932 c1.127,0.585,2.168,0.839,2.527,0.916c-0.938-2.56-2.535-3.742-3.719-4.283C71.901,14.04,70.97,13.974,70.669,13.966z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#06065C",
    d: "M73.633,22.05c0,0.142-0.005,0.289-0.018,0.44c-0.11,1.349-0.813,3.285-3.537,4.853l-0.079,0.045 l-0.033-0.084c-0.016-0.04-0.376-0.985-0.175-2.381c0.185-1.284,0.905-3.2,3.285-5.04l0.076-0.059l0.042,0.086 C73.214,19.95,73.633,20.817,73.633,22.05z M70.082,27.16c2.055-1.208,3.223-2.823,3.377-4.675 c0.099-1.187-0.247-2.132-0.366-2.417c-2.276,1.789-2.969,3.637-3.147,4.878C69.785,26.063,70,26.897,70.082,27.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#06065C",
    d: "M84.396,18.84l-0.023,0.154c-9.791-1.522-15.818,3.11-16.474,3.643l-0.008,0.006l-0.098-0.122 l0.007-0.006C68.461,21.978,74.539,17.307,84.396,18.84z"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M73.717,34.141c0,0-2.923,3.845,0.002,5.884c2.925,2.039,4.243-0.582,3.515-1.517 c-0.73-0.936-1.263-1.578-0.438-1.584c0.826-0.006,2.725,5.538,6.146,4.708c3.422-0.83,2.642-3.534,1.061-4.26 c-1.582-0.727-5.629-1.259-5.713-2.316c-0.082-1.057,0.501-1.247,1.402-0.625c0.902,0.622,2.389-0.311,1.589-1.914 C80.481,30.915,74.927,29.939,73.717,34.141z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M72.018,67.009c0,0,4.819,0.326,4.913-3.238c0.092-3.564-2.821-3.224-3.201-2.1 c-0.38,1.123-0.623,1.922-1.083,1.236c-0.459-0.687,3.125-5.323,0.55-7.724c-2.575-2.401-4.404-0.262-4.14,1.458 c0.263,1.72,2.046,5.392,1.209,6.043s-1.316,0.269-1.293-0.827c0.022-1.094-1.574-1.822-2.472-0.272 C65.602,63.136,67.844,68.312,72.018,67.009z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "#E54750",
    cx: 91.742,
    cy: 28.366,
    r: 6.681
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    fill: "#FFFFFF",
    cx: 86.86,
    cy: 28.197,
    rx: 0.684,
    ry: 1.528
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M88.322,31.473c-0.385,0.291-0.465,0.835-0.186,1.228c0.29,0.408,0.735,0.826,1.304,0.712 c0.803-0.161,0.598-1.328,0.453-1.877c-0.045-0.173-0.199-0.295-0.377-0.299c-0.345-0.007-0.902,0.017-1.182,0.227 C88.331,31.466,88.326,31.47,88.322,31.473z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#FFFFFF",
    cx: 90.886,
    cy: 24.045,
    rx: 0.856,
    ry: 1.238
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(-0.2506 -0.9681 0.9681 -0.2506 84.0186 131.808)",
    fill: "#FFFFFF",
    cx: 93.023,
    cy: 33.386,
    rx: 0.658,
    ry: 0.842
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(-0.2497 -0.9683 0.9683 -0.2497 85.6072 116.8976)",
    fill: "#FFFFFF",
    cx: 88.092,
    cy: 25.283,
    rx: 0.417,
    ry: 0.533
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(-0.2497 -0.9683 0.9683 -0.2497 87.2079 129.4641)",
    fill: "#FFFFFF",
    cx: 93.761,
    cy: 30.946,
    rx: 0.417,
    ry: 0.532
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(-0.9734 -0.2293 0.2293 -0.9734 182.9963 83.3804)",
    fill: "#FFFFFF",
    cx: 96.342,
    cy: 31.06,
    rx: 0.416,
    ry: 0.533
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(-0.842 -0.5396 0.5396 -0.842 158.4711 96.9862)",
    fill: "#FFFFFF",
    cx: 93.44,
    cy: 25.283,
    rx: 0.677,
    ry: 0.867
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#FFFFFF",
    cx: 94.288,
    cy: 28.619,
    rx: 1.264,
    ry: 0.896
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.8661 -0.4998 0.4998 0.8661 -2.2469 49.203)",
    fill: "#FFFFFF",
    cx: 90.726,
    cy: 28.796,
    rx: 0.896,
    ry: 1.264
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M95.52,25.018c-0.349,0.229-0.472,0.684-0.312,1.069c0.34,0.818,1.098,2.344,1.767,1.636 C97.749,26.903,96.599,24.308,95.52,25.018z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "#E54750",
    cx: 82.977,
    cy: 51.476,
    r: 6.681
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    fill: "#FFFFFF",
    cx: 78.094,
    cy: 51.307,
    rx: 0.685,
    ry: 1.528
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M79.556,54.583c-0.384,0.291-0.464,0.835-0.186,1.228c0.291,0.408,0.736,0.825,1.305,0.711 c0.803-0.16,0.598-1.328,0.453-1.876c-0.045-0.173-0.199-0.295-0.378-0.299c-0.344-0.007-0.901,0.017-1.181,0.227 C79.564,54.577,79.561,54.58,79.556,54.583z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#FFFFFF",
    cx: 82.12,
    cy: 47.155,
    rx: 0.856,
    ry: 1.238
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(-0.2499 -0.9683 0.9683 -0.2499 50.6053 152.1969)",
    fill: "#FFFFFF",
    cx: 84.257,
    cy: 56.496,
    rx: 0.659,
    ry: 0.843
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(-0.2498 -0.9683 0.9683 -0.2498 52.2877 137.2943)",
    fill: "#FFFFFF",
    cx: 79.327,
    cy: 48.393,
    rx: 0.416,
    ry: 0.533
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(-0.2486 -0.9686 0.9686 -0.2486 53.7659 149.8214)",
    fill: "#FFFFFF",
    cx: 84.995,
    cy: 54.056,
    rx: 0.416,
    ry: 0.533
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(-0.9735 -0.2287 0.2287 -0.9735 160.4417 126.9338)",
    fill: "#FFFFFF",
    cx: 87.576,
    cy: 54.17,
    rx: 0.416,
    ry: 0.533
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(-0.842 -0.5396 0.5396 -0.842 129.8562 134.8239)",
    fill: "#FFFFFF",
    cx: 84.675,
    cy: 48.393,
    rx: 0.677,
    ry: 0.867
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#FFFFFF",
    cx: 85.522,
    cy: 51.729,
    rx: 1.264,
    ry: 0.896
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.8661 -0.4998 0.4998 0.8661 -14.9715 47.9155)",
    fill: "#FFFFFF",
    cx: 81.96,
    cy: 51.906,
    rx: 0.896,
    ry: 1.265
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M86.753,48.128c-0.348,0.229-0.471,0.683-0.311,1.069c0.34,0.818,1.098,2.345,1.766,1.636 C88.983,50.013,87.833,47.418,86.753,48.128z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "#E54750",
    cx: 55.949,
    cy: 30.59,
    r: 5.079
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    fill: "#FFFFFF",
    cx: 52.237,
    cy: 30.462,
    rx: 0.521,
    ry: 1.161
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M53.349,32.952c-0.292,0.221-0.354,0.635-0.142,0.934c0.221,0.31,0.56,0.627,0.992,0.541 c0.609-0.122,0.454-1.01,0.344-1.427c-0.035-0.131-0.151-0.224-0.288-0.227c-0.261-0.006-0.685,0.013-0.898,0.172 C53.355,32.947,53.352,32.95,53.349,32.952z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#FFFFFF",
    cx: 55.298,
    cy: 27.305,
    rx: 0.651,
    ry: 0.941
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(-0.2496 -0.9683 0.9683 -0.2496 37.8158 98.1167)",
    fill: "#FFFFFF",
    cx: 56.923,
    cy: 34.407,
    rx: 0.501,
    ry: 0.64
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(-0.2498 -0.9683 0.9683 -0.2498 39.1057 86.7903)",
    fill: "#FFFFFF",
    cx: 53.174,
    cy: 28.246,
    rx: 0.317,
    ry: 0.405
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(-0.25 -0.9683 0.9683 -0.25 40.3351 96.3474)",
    fill: "#FFFFFF",
    cx: 57.484,
    cy: 32.552,
    rx: 0.316,
    ry: 0.405
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(-0.9734 -0.2291 0.2291 -0.9734 109.835 78.026)",
    fill: "#FFFFFF",
    cx: 59.446,
    cy: 32.638,
    rx: 0.317,
    ry: 0.405
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(-0.8421 -0.5393 0.5393 -0.8421 90.2097 82.9019)",
    fill: "#FFFFFF",
    cx: 57.24,
    cy: 28.246,
    rx: 0.515,
    ry: 0.659
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#FFFFFF",
    cx: 57.884,
    cy: 30.782,
    rx: 0.961,
    ry: 0.681
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.8662 -0.4998 0.4998 0.8662 -8.0664 31.7132)",
    fill: "#FFFFFF",
    cx: 55.177,
    cy: 30.917,
    rx: 0.681,
    ry: 0.961
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M58.821,28.044c-0.266,0.174-0.359,0.52-0.237,0.813c0.259,0.622,0.834,1.782,1.343,1.244 C60.516,29.478,59.641,27.505,58.821,28.044z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "#E54750",
    cx: 57.663,
    cy: 56.248,
    r: 6.68
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    fill: "#FFFFFF",
    cx: 52.78,
    cy: 56.08,
    rx: 0.685,
    ry: 1.528
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M54.243,59.355c-0.384,0.29-0.465,0.835-0.186,1.228c0.29,0.408,0.736,0.826,1.305,0.713 c0.802-0.161,0.597-1.328,0.453-1.877c-0.045-0.173-0.2-0.295-0.378-0.299c-0.344-0.007-0.901,0.017-1.181,0.227 C54.251,59.349,54.247,59.353,54.243,59.355z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#FFFFFF",
    cx: 56.806,
    cy: 51.927,
    rx: 0.857,
    ry: 1.238
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(-0.2499 -0.9683 0.9683 -0.2499 14.345 133.6524)",
    fill: "#FFFFFF",
    cx: 58.944,
    cy: 61.27,
    rx: 0.659,
    ry: 0.843
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(-0.2498 -0.9683 0.9683 -0.2498 16.0283 118.7491)",
    fill: "#FFFFFF",
    cx: 54.013,
    cy: 53.166,
    rx: 0.416,
    ry: 0.533
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(-0.2498 -0.9683 0.9683 -0.2498 17.6295 131.3157)",
    fill: "#FFFFFF",
    cx: 59.682,
    cy: 58.829,
    rx: 0.416,
    ry: 0.533
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(-0.9734 -0.2293 0.2293 -0.9734 109.3532 130.5901)",
    fill: "#FFFFFF",
    cx: 62.263,
    cy: 58.943,
    rx: 0.416,
    ry: 0.533
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(-0.8421 -0.5394 0.5394 -0.8421 80.6693 129.9531)",
    fill: "#FFFFFF",
    cx: 59.361,
    cy: 53.166,
    rx: 0.678,
    ry: 0.867
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#FFFFFF",
    cx: 60.208,
    cy: 56.501,
    rx: 1.265,
    ry: 0.896
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.8661 -0.5 0.5 0.8661 -20.7489 35.9125)",
    fill: "#FFFFFF",
    cx: 56.647,
    cy: 56.679,
    rx: 0.896,
    ry: 1.264
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M61.44,52.9c-0.349,0.229-0.472,0.684-0.312,1.069c0.34,0.818,1.098,2.344,1.767,1.636 C63.669,54.786,62.519,52.191,61.44,52.9z"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "#06065C",
    d: "M97.915,27.626c0,3.695-3.006,6.701-6.701,6.701c-3.694,0-6.701-3.006-6.701-6.701 c0-3.695,3.007-6.701,6.701-6.701C94.909,20.925,97.915,23.931,97.915,27.626z M84.669,27.626c0,3.609,2.937,6.545,6.545,6.545 c3.609,0,6.546-2.936,6.546-6.545s-2.937-6.545-6.546-6.545C87.605,21.081,84.669,24.018,84.669,27.626z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#06065C",
    d: "M89.905,54.119c0,3.695-3.006,6.7-6.701,6.7s-6.701-3.005-6.701-6.7c0-3.695,3.006-6.701,6.701-6.701 S89.905,50.424,89.905,54.119z M76.659,54.119c0,3.609,2.936,6.545,6.545,6.545s6.545-2.936,6.545-6.545 c0-3.609-2.936-6.545-6.545-6.545S76.659,50.51,76.659,54.119z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#06065C",
    d: "M63.348,54.875c0,3.695-3.006,6.701-6.701,6.701s-6.701-3.006-6.701-6.701 c0-3.695,3.006-6.701,6.701-6.701S63.348,51.18,63.348,54.875z M50.102,54.875c0,3.609,2.937,6.545,6.545,6.545 s6.545-2.937,6.545-6.545c0-3.609-2.936-6.545-6.545-6.545S50.102,51.266,50.102,54.875z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#70C6B7",
    d: "M102.077,34.039c0,1.586-0.109,3.157-0.328,4.7c-0.307,2.166-0.828,4.28-1.551,6.284 c-1.23,3.415-2.64,5.355-2.653,5.374l-0.21-0.153c0.014-0.019,1.404-1.936,2.623-5.319c1.123-3.122,2.325-8.165,1.674-14.468 l0.258-0.026C102.015,31.637,102.077,32.842,102.077,34.039z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#70C6B7",
    d: "M99.958,44.924c0,0-3.701,4.685-8.531,2.946C91.427,47.871,93.562,43.479,99.958,44.924z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#70C6B7",
    d: "M100.9,42.813c0,0-0.395,6.08,3.161,7.583C104.062,50.397,106.115,46.448,100.9,42.813z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#70C6B7",
    d: "M101.358,39.534c0,0-2.037,2.194-4.408,0.879C96.95,40.413,99.049,37.914,101.358,39.534z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#70C6B7",
    d: "M101.749,38.739c0,0,0.574,3.917,3.577,3.679C105.326,42.418,106.232,39.326,101.749,38.739z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#70C6B7",
    d: "M101.812,34.543c0,0-0.846,2.482-3.684,1.385C98.128,35.928,99.798,34.096,101.812,34.543z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#70C6B7",
    d: "M102.077,34.039c0,0,0.238,2.69,3.324,3.006C105.401,37.045,105.862,34.51,102.077,34.039z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#06065C",
    d: "M100.317,47.162l-0.076,0.097c-0.01,0.012-0.951,1.193-2.475,2.143c-1.409,0.88-3.619,1.737-6.144,0.829 l-0.081-0.029l0.037-0.078c0.022-0.045,0.559-1.127,1.893-2.045c1.229-0.846,3.394-1.696,6.725-0.943L100.317,47.162z  M91.761,50.113c2.428,0.837,4.557,0.008,5.92-0.841c1.248-0.778,2.101-1.714,2.357-2.013c-3.201-0.69-5.283,0.127-6.471,0.942 C92.465,48.958,91.909,49.849,91.761,50.113z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#06065C",
    d: "M104.345,50.753c0,1.167-0.389,1.93-0.407,1.966l-0.033,0.064l-0.065-0.028 c-1.479-0.625-2.503-2.151-2.961-4.412c-0.344-1.698-0.25-3.233-0.248-3.249l0.008-0.138l0.114,0.079 c2.718,1.895,3.44,3.88,3.569,5.212C104.338,50.423,104.345,50.592,104.345,50.753z M103.83,52.582 c0.107-0.242,0.452-1.131,0.335-2.329c-0.125-1.277-0.816-3.175-3.387-5.008c-0.014,0.415-0.027,1.688,0.253,3.07 C101.339,49.834,102.075,51.797,103.83,52.582z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#06065C",
    d: "M101.282,41.808l-0.061,0.065c-0.021,0.023-0.529,0.563-1.338,0.95c-0.752,0.358-1.911,0.64-3.165-0.055 l-0.083-0.046l0.061-0.072c0.022-0.026,0.545-0.642,1.362-1.066c0.761-0.395,1.926-0.686,3.15,0.173L101.282,41.808z  M96.881,42.678c0.933,0.485,1.919,0.488,2.931,0.006c0.623-0.296,1.072-0.698,1.231-0.853 c-0.909-0.603-1.888-0.641-2.908-0.112C97.503,42.046,97.044,42.503,96.881,42.678z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#06065C",
    d: "M105.288,44.066c0,0.378-0.074,0.638-0.08,0.66l-0.016,0.052l-0.053,0.004 c-1.262,0.1-2.295-0.52-2.99-1.791c-0.52-0.951-0.664-1.914-0.67-1.955l-0.016-0.102l0.102,0.013 c1.611,0.211,2.72,0.765,3.294,1.647C105.203,43.121,105.288,43.662,105.288,44.066z M105.071,44.63 c0.049-0.222,0.201-1.118-0.344-1.953c-0.537-0.821-1.571-1.347-3.076-1.561c0.053,0.274,0.227,1.053,0.637,1.803 C102.95,44.129,103.887,44.704,105.071,44.63z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#06065C",
    d: "M101.72,36.772l-0.027,0.082c-0.015,0.042-0.361,1.031-1.348,1.492 c-0.688,0.321-1.508,0.301-2.438-0.059l-0.106-0.041l0.077-0.084c0.017-0.019,1.723-1.861,3.758-1.409L101.72,36.772z  M98.075,38.184c0.842,0.303,1.582,0.31,2.201,0.021c0.767-0.356,1.131-1.075,1.234-1.318 C99.852,36.574,98.425,37.84,98.075,38.184z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#06065C",
    d: "M105.304,39.069c0,0.162-0.018,0.264-0.02,0.276l-0.012,0.071l-0.072-0.007 c-1.625-0.167-2.462-0.993-2.877-1.658c-0.45-0.719-0.514-1.391-0.517-1.419l-0.009-0.096l0.096,0.012 c1.396,0.174,2.387,0.644,2.94,1.398C105.235,38.191,105.304,38.748,105.304,39.069z M105.14,39.245 c0.02-0.215,0.032-0.878-0.434-1.51c-0.515-0.699-1.434-1.143-2.73-1.32c0.035,0.209,0.148,0.726,0.483,1.259 C103.024,38.575,103.927,39.103,105.14,39.245z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#06065C",
    d: "M101.858,34.494c-0.105,4.631-0.688,9.242-1.729,13.704c-0.831,3.558-1.731,6.027-2.07,6.956 c-0.083,0.226-0.147,0.404-0.152,0.437c0.001-0.009-0.001-0.032-0.018-0.052l-0.058,0.05v0.08l-0.065-0.034 c-0.032-0.046-0.032-0.046,0.146-0.534c2.927-8.024,3.677-15.637,3.79-20.61L101.858,34.494z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M88.979,68.999c0,0,0.135,4.345,2.821,4.029c2.688-0.316,4.004-0.552,4.135-2.37 c0.133-1.817-1.514-0.632-1.836-1.659c-0.323-1.027,2.259-1.344,3.892-0.633s4.093-0.316,3.417-3.871 c-0.678-3.557-6.764,1.658-7.554,1.105s-0.521-2.422,0.886-2.357c1.406,0.066,0.854-2.936-1.676-2.937 C90.536,60.306,87.975,63.862,88.979,68.999z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.4252 -0.9051 0.9051 0.4252 4.0008 79.9167)",
    fill: "#06065C",
    cx: 64.917,
    cy: 36.809,
    rx: 3.279,
    ry: 2.099
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M66.53,36.283c0,0.751-0.17,1.388-0.51,1.904c-0.647,0.983-1.668,1.148-1.711,1.155l-0.031-0.206 l0.016,0.103l-0.016-0.103c0.01-0.001,0.976-0.16,1.571-1.066c0.54-0.823,0.619-1.99,0.232-3.467l0.201-0.053 C66.447,35.182,66.53,35.76,66.53,36.283z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9797 0.2005 -0.2005 0.9797 4.6974 -10.5566)",
    fill: "#06065C",
    cx: 54.456,
    cy: 17.908,
    rx: 2.389,
    ry: 1.529
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M55.104,18.959c-0.532,0.128-1.011,0.117-1.435-0.035c-0.807-0.291-1.099-0.984-1.11-1.014l0.14-0.057 l-0.07,0.029l0.07-0.029c0.002,0.006,0.28,0.664,1.024,0.93c0.675,0.241,1.514,0.097,2.494-0.429l0.071,0.133 C55.87,18.712,55.474,18.87,55.104,18.959z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9797 0.2005 -0.2005 0.9797 15.3644 -15.1447)",
    fill: "#06065C",
    cx: 82.454,
    cy: 68.284,
    rx: 3.519,
    ry: 2.252
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M83.408,69.833c-0.783,0.189-1.491,0.172-2.114-0.052c-1.188-0.427-1.618-1.45-1.636-1.493l0.206-0.084 l-0.103,0.042l0.103-0.042c0.004,0.01,0.414,0.977,1.51,1.369c0.994,0.355,2.23,0.143,3.674-0.632l0.105,0.196 C84.536,69.47,83.954,69.701,83.408,69.833z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(-0.0435 0.9991 -0.9991 -0.0435 165.3584 -45.3221)",
    fill: "#06065C",
    cx: 104.375,
    cy: 56.496,
    rx: 2.761,
    ry: 1.767
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M103.293,57.428c-0.244-0.583-0.318-1.133-0.222-1.645c0.184-0.974,0.923-1.433,0.954-1.452l0.091,0.149 l-0.045-0.075l0.045,0.075c-0.007,0.004-0.706,0.441-0.874,1.338c-0.152,0.815,0.165,1.747,0.944,2.769l-0.139,0.106 C103.714,58.257,103.462,57.834,103.293,57.428z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    fill: "#06065C",
    cx: 89.644,
    cy: 40.037,
    rx: 2.099,
    ry: 3.279
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M91.015,39.69c0,1.403-0.879,2.72-0.922,2.782l-0.129-0.087c0.012-0.017,1.143-1.713,0.843-3.246 c-0.128-0.653-0.498-1.189-1.101-1.593l0.087-0.129c0.639,0.428,1.03,0.998,1.167,1.693 C90.997,39.303,91.015,39.497,91.015,39.69z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(-0.7954 -0.6061 0.6061 -0.7954 86.9728 123.5721)",
    fill: "#06065C",
    cx: 64.344,
    cy: 47.106,
    rx: 3.279,
    ry: 2.099
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M64.898,45.806c1.116,0.85,1.63,2.347,1.655,2.418l-0.148,0.05c-0.006-0.019-0.67-1.947-2.071-2.637 c-0.597-0.294-1.248-0.325-1.934-0.09l-0.05-0.147c0.727-0.249,1.418-0.215,2.054,0.098 C64.58,45.584,64.745,45.688,64.898,45.806z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.3742 0.9274 -0.9274 0.3742 92.5194 -6.3741)",
    fill: "#06065C",
    cx: 50.982,
    cy: 65.362,
    rx: 3.279,
    ry: 2.099
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M49.841,66.196c-0.525-1.301-0.203-2.851-0.187-2.924l0.152,0.032c-0.004,0.021-0.418,2.016,0.433,3.325 c0.363,0.559,0.906,0.916,1.617,1.065l-0.032,0.153c-0.752-0.158-1.33-0.54-1.715-1.135 C50.001,66.55,49.913,66.376,49.841,66.196z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#70C6B7",
    d: "M82.454,75.151c-3.424,0.455-6.733,0.484-9.837,0.084c-2.484-0.318-4.843-0.912-7.011-1.762 c-3.695-1.448-5.582-3.167-5.601-3.183l0.118-0.129c0.019,0.018,1.887,1.719,5.555,3.154c3.386,1.326,9.04,2.689,16.752,1.664 L82.454,75.151z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#70C6B7",
    d: "M77.249,75.299c0,0-5.982-0.826-6.724-5.684C70.525,69.615,75.256,68.587,77.249,75.299z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#70C6B7",
    d: "M71.805,75.032c0,0-2.096,4.98-7.682,1.951C64.123,76.983,66.361,74.764,71.805,75.032z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#70C6B7",
    d: "M64.887,73.084c0,0-4.22-1.396-4.622-8.103C60.265,64.981,65.191,66.905,64.887,73.084z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#06065C",
    d: "M76.942,75.264l-0.127-0.012c-0.016-0.002-1.598-0.156-3.228-0.902 c-2.169-0.992-3.438-2.573-3.671-4.573l-0.012-0.097h0.098c0.055,0,1.359,0.004,2.874,0.676 c1.398,0.621,3.234,1.957,4.031,4.787L76.942,75.264z M70.101,69.857c0.258,1.915,1.454,3.374,3.559,4.334 c1.337,0.613,2.64,0.82,3.044,0.873c-0.797-2.677-2.551-3.949-3.893-4.546C71.564,69.962,70.434,69.872,70.101,69.857z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#06065C",
    d: "M71.983,74.967l-0.114,0.123c-0.01,0.012-1.003,1.082-2.565,1.801c-1.446,0.666-3.688,1.16-6.164-0.262 l-0.066-0.039l0.029-0.07c0.01-0.025,0.275-0.645,1.497-1.146c1.105-0.453,3.255-0.896,7.216-0.428L71.983,74.967z M63.3,76.52 c2.38,1.332,4.533,0.855,5.926,0.217c1.219-0.561,2.084-1.34,2.392-1.639c-3.787-0.428-5.854-0.008-6.924,0.426 C63.756,75.901,63.404,76.352,63.3,76.52z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#06065C",
    d: "M64.949,73.233l-0.112-0.078c-0.041-0.027-1-0.694-1.89-2.014c-0.821-1.219-1.724-3.241-1.364-5.958 l0.019-0.142l0.117,0.081c0.01,0.008,1.042,0.738,1.953,2.078c0.84,1.238,1.749,3.266,1.3,5.898L64.949,73.233z M61.737,65.354 c-0.301,2.585,0.563,4.514,1.351,5.685c0.697,1.035,1.456,1.674,1.736,1.892c0.383-2.505-0.486-4.439-1.292-5.627 C62.819,66.251,62.03,65.583,61.737,65.354z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#06065C",
    d: "M78.309,75.405c-1.973,0.52-5.39,0.119-10.157-1.188c-3.543-0.973-6.55-2.113-6.58-2.125l0.062-0.162 c0.119,0.045,11.991,4.529,16.631,3.306L78.309,75.405z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#70C6B7",
    d: "M42.563,29.495c1.252-1.931,2.672-3.62,4.219-5.019c1.239-1.12,2.561-2.057,3.931-2.787 c2.334-1.244,4.022-1.455,4.039-1.457l0.014,0.115c-0.017,0.002-1.688,0.211-4.004,1.447c-2.138,1.141-5.279,3.413-8.102,7.764 L42.563,29.495z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#70C6B7",
    d: "M44.743,26.794c0,0,3.011-2.671,5.792-0.942C50.536,25.853,49.007,28.694,44.743,26.794z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#70C6B7",
    d: "M47.237,24.153c0,0-1.614-3.219,2.34-4.736C49.578,19.417,49.731,21.512,47.237,24.153z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#70C6B7",
    d: "M51.222,21.494c0,0,2.536-1.532,6.106,1.17C57.329,22.664,54.22,24.326,51.222,21.494z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#06065C",
    d: "M44.895,26.655l0.061-0.059c0.007-0.007,0.771-0.742,1.855-1.245c1.442-0.668,2.793-0.626,3.907,0.123 l0.054,0.036l-0.042,0.049c-0.024,0.028-0.591,0.687-1.588,1.162c-0.921,0.439-2.392,0.791-4.171-0.032L44.895,26.655z  M50.597,25.533c-1.082-0.699-2.339-0.725-3.738-0.077c-0.89,0.413-1.559,0.982-1.761,1.165c1.701,0.756,3.106,0.419,3.99-0.001 C49.91,26.228,50.445,25.695,50.597,25.533z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#06065C",
    d: "M47.194,24.272l-0.014-0.112c-0.001-0.01-0.112-0.977,0.2-2.079c0.29-1.021,1.011-2.371,2.804-3.008 l0.048-0.017l0.023,0.045c0.009,0.017,0.208,0.419-0.068,1.254c-0.249,0.757-0.956,2.037-2.91,3.84L47.194,24.272z  M50.169,19.202c-1.707,0.628-2.398,1.925-2.677,2.908c-0.245,0.86-0.226,1.635-0.207,1.921c1.857-1.732,2.54-2.961,2.785-3.691 C50.285,19.701,50.209,19.327,50.169,19.202z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#06065C",
    d: "M51.12,21.461l0.087-0.023c0.032-0.008,0.786-0.206,1.839-0.084c0.973,0.112,2.389,0.531,3.609,1.891 l0.063,0.071l-0.092,0.023c-0.008,0.002-0.825,0.209-1.898,0.089c-0.991-0.11-2.412-0.529-3.551-1.897L51.12,21.461z  M56.502,23.249c-1.179-1.272-2.53-1.67-3.464-1.779c-0.827-0.096-1.479,0.011-1.71,0.06c1.103,1.279,2.458,1.677,3.41,1.784 C55.579,23.408,56.259,23.297,56.502,23.249z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#06065C",
    d: "M44.231,27.286c0.591-1.224,2.275-2.782,5.003-4.629c2.028-1.374,3.908-2.402,3.927-2.412l0.055,0.102 c-0.075,0.041-7.49,4.11-8.88,6.99L44.231,27.286z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#70C6B7",
    d: "M43.543,58.603c-0.2-3.094-0.024-6.06,0.522-8.815c0.437-2.206,1.111-4.283,2.004-6.173 c1.521-3.221,3.175-4.807,3.191-4.822l0.107,0.113c-0.017,0.016-1.653,1.586-3.162,4.784 c-1.393,2.952-2.958,7.934-2.508,14.903L43.543,58.603z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#70C6B7",
    d: "M43.726,53.932c0,0,1.104-5.307,5.5-5.676C49.226,48.256,49.86,52.555,43.726,53.932z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#70C6B7",
    d: "M44.296,49.073c0,0-4.333-2.18-1.281-6.999C43.015,42.074,44.866,44.214,44.296,49.073z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#70C6B7",
    d: "M46.461,42.995c0,0,1.506-3.694,7.538-3.648C53.999,39.347,51.977,43.643,46.461,42.995z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#06065C",
    d: "M43.776,53.66l0.019-0.112c0.002-0.014,0.237-1.422,1.004-2.837c1.02-1.882,2.514-2.923,4.319-3.01 l0.087-0.004l-0.005,0.087c-0.003,0.049-0.086,1.218-0.78,2.533c-0.641,1.215-1.948,2.778-4.531,3.32L43.776,53.66z  M49.035,47.861c-1.731,0.114-3.109,1.098-4.1,2.924c-0.629,1.161-0.894,2.315-0.965,2.674c2.445-0.551,3.691-2.045,4.308-3.21 C48.852,49.165,49.001,48.158,49.035,47.861z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#06065C",
    d: "M44.345,49.237l-0.105-0.11c-0.009-0.01-0.907-0.964-1.456-2.406c-0.508-1.335-0.815-3.375,0.609-5.505 l0.038-0.057l0.061,0.03c0.023,0.011,0.562,0.286,0.936,1.41c0.339,1.018,0.605,2.97-0.055,6.489L44.345,49.237z M43.48,41.366 c-1.338,2.051-1.042,4.008-0.553,5.294c0.427,1.126,1.072,1.948,1.321,2.241c0.613-3.365,0.362-5.242,0.04-6.228 C44.006,41.812,43.624,41.469,43.48,41.366z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#06065C",
    d: "M46.325,43.042l0.075-0.096c0.027-0.035,0.684-0.854,1.92-1.57c1.141-0.661,3.007-1.347,5.418-0.86 l0.126,0.025l-0.081,0.1c-0.007,0.009-0.723,0.889-1.979,1.623c-1.16,0.678-3.032,1.368-5.363,0.806L46.325,43.042z  M53.577,40.644c-2.297-0.427-4.077,0.23-5.173,0.864c-0.971,0.561-1.588,1.202-1.8,1.44c2.22,0.495,4.004-0.166,5.118-0.815 C52.708,41.558,53.354,40.892,53.577,40.644z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#06065C",
    d: "M43.568,54.875c-0.346-1.798,0.22-4.835,1.681-9.025c1.086-3.115,2.289-5.738,2.301-5.764l0.142,0.065 c-0.048,0.104-4.785,10.465-3.971,14.694L43.568,54.875z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#06065C",
    d: "M51.752,4.957c-8.081,2.928-12.737,8.364-15.22,12.409c-2.692,4.386-3.482,8.128-3.49,8.166 l-0.204-0.042c0.008-0.038,0.803-3.809,3.512-8.226c1.591-2.593,3.521-4.9,5.738-6.855c2.771-2.445,5.998-4.345,9.592-5.647 L51.752,4.957z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#06065C",
    d: "M48.794,3.738C40.71,6.667,36.053,12.106,33.57,16.154c-2.69,4.385-3.479,8.122-3.486,8.159 l-0.204-0.042c0.008-0.038,0.803-3.81,3.512-8.226c1.591-2.594,3.522-4.9,5.738-6.856c2.771-2.445,5.998-4.345,9.593-5.647 L48.794,3.738z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#6FC3C4",
    d: "M141.249,125.083L14.04,125.489l-0.173-54.01c-0.014-4.261,3.43-7.728,7.274-7.739l111.777-0.357 c4.679-0.016,8.144,3.428,8.157,7.689L141.249,125.083z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#010060",
    d: "M13.547,125.987l-0.175-54.507c-0.007-2.168,0.82-4.229,2.328-5.806c1.47-1.538,3.453-2.423,5.439-2.429 l111.777-0.358c2.375-0.017,4.562,0.837,6.172,2.379c1.593,1.526,2.475,3.587,2.481,5.804l0.175,54.505l-0.495,0.002 L13.547,125.987z M132.948,63.876c-0.01,0-0.02,0-0.028,0L21.143,64.233c-1.719,0.006-3.442,0.779-4.728,2.124 c-1.33,1.391-2.06,3.208-2.053,5.12l0.171,53.515l126.22-0.402l-0.172-53.517c-0.006-1.945-0.779-3.755-2.177-5.094 C136.987,64.622,135.05,63.876,132.948,63.876z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 24.007,
    y: 97.689,
    transform: "matrix(1 -0.0032 0.0032 1 -0.3576 0.2503)",
    fill: "#6FC3C4",
    width: 108.024,
    height: 28.361
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#010060",
    d: "M23.56,126.719l-0.094-29.35l0.495-0.002l108.518-0.348l0.094,29.352l-0.494,0.002L23.56,126.719z  M24.458,98.356l0.087,27.371l107.034-0.342l-0.088-27.373L24.458,98.356z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M25.543,70.833c-1.588,0.005-1.583,2.472,0.008,2.468C27.139,73.295,27.134,70.828,25.543,70.833z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M36.657,89.983c-1.588,0.006-1.583,2.473,0.008,2.467C38.253,92.446,38.248,89.977,36.657,89.983z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M50.561,68.459c-1.588,0.005-1.583,2.473,0.008,2.468C52.156,70.921,52.151,68.454,50.561,68.459z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M62.099,89.901c-1.588,0.006-1.583,2.473,0.008,2.469C63.695,92.364,63.689,89.897,62.099,89.901z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M78.298,68.787c-1.588,0.005-1.583,2.473,0.008,2.468C79.894,71.25,79.888,68.782,78.298,68.787z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M92.128,89.596c-1.588,0.006-1.582,2.473,0.008,2.469C93.724,92.059,93.718,89.592,92.128,89.596z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M107.907,67.649c-1.588,0.006-1.583,2.473,0.008,2.468C109.503,70.112,109.497,67.645,107.907,67.649z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M120.077,90.967c-1.588,0.004-1.583,2.473,0.008,2.467C121.673,93.43,121.667,90.961,120.077,90.967z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M131.269,69.452c-1.588,0.005-1.582,2.473,0.008,2.467C132.864,71.915,132.859,69.446,131.269,69.452z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M128.567,122.975l-100.771,0.322c-1.152,0.004-2.088-0.926-2.092-2.078l0,0 c-0.004-1.152,0.927-2.088,2.079-2.092l100.771-0.322c1.151-0.004,2.089,0.926,2.093,2.078l0,0 C130.65,122.036,129.72,122.971,128.567,122.975z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M77.694,107.401l-52.378,0.166c-0.673,0.004-1.222-0.543-1.224-1.217l-0.022-6.854 c-0.002-0.672,0.543-1.223,1.217-1.225l52.377-0.166c0.673-0.004,1.223,0.543,1.226,1.215l0.021,6.855 C78.913,106.848,78.367,107.399,77.694,107.401z M25.288,98.684c-0.446,0.002-0.808,0.365-0.807,0.812l0.022,6.854 c0.001,0.445,0.366,0.809,0.812,0.807l52.377-0.168c0.447-0.002,0.809-0.365,0.807-0.812l-0.021-6.854 c-0.002-0.445-0.365-0.809-0.812-0.807L25.288,98.684z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M132.177,107.198l-52.634,0.17c-0.603,0.002-1.095-0.488-1.097-1.09l-0.022-7.109 c-0.002-0.604,0.487-1.094,1.09-1.096l52.633-0.17c0.603-0.002,1.095,0.488,1.097,1.09l0.023,7.109 C133.269,106.706,132.779,107.196,132.177,107.198z M79.515,98.483c-0.376,0.002-0.681,0.309-0.68,0.684l0.023,7.109 c0,0.377,0.308,0.682,0.684,0.68l52.633-0.168c0.376-0.002,0.682-0.309,0.68-0.684l-0.022-7.109 c-0.001-0.377-0.308-0.682-0.685-0.68L79.515,98.483z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#6FC3C4",
    d: "M24.061,128.793L6.543,128.85L6.421,90.573c-0.007-2.355,1.896-4.27,4.251-4.277l8.988-0.029 c2.355-0.008,4.271,1.896,4.278,4.252L24.061,128.793z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#010060",
    d: "M6.05,129.346L5.926,90.575c-0.008-2.625,2.12-4.766,4.744-4.773l8.988-0.029c0.005,0,0.011,0,0.016,0 c1.266,0,2.456,0.49,3.354,1.383c0.902,0.896,1.401,2.09,1.405,3.361l0.124,38.771L6.05,129.346z M19.674,86.76 c-0.004,0-0.008,0-0.012,0l-8.988,0.029c-2.079,0.006-3.765,1.703-3.758,3.781l0.121,37.783l16.528-0.053l-0.121-37.783 c-0.003-1.006-0.398-1.951-1.113-2.662C21.619,87.149,20.676,86.76,19.674,86.76z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#6FC3C4",
    d: "M149.504,128.393l-17.518,0.057l-0.119-37.254c-0.009-2.92,2.351-5.297,5.272-5.305l6.939-0.023 c2.92-0.01,5.296,2.352,5.305,5.271L149.504,128.393z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#010060",
    d: "M131.493,128.946l-0.121-37.748c-0.004-1.545,0.592-3,1.682-4.096c1.089-1.096,2.539-1.701,4.084-1.707 l6.939-0.021c0.006,0,0.013,0,0.019,0c1.538,0,2.985,0.596,4.076,1.682c1.097,1.088,1.702,2.539,1.707,4.084L150,128.885 L131.493,128.946z M144.096,86.362c-0.005,0-0.011,0-0.016,0l-6.938,0.023c-1.281,0.004-2.484,0.506-3.387,1.414 s-1.396,2.115-1.393,3.395l0.117,36.758l16.527-0.051l-0.117-36.76c-0.004-1.279-0.506-2.482-1.415-3.385 C146.57,86.856,145.37,86.362,144.096,86.362z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M8.54,102.075H8.129L8.1,92.842c-0.007-2.027,1.637-3.682,3.665-3.688l7.03-0.023 c2.027-0.006,3.682,1.637,3.688,3.664l0.03,9.125h-0.412l-0.029-9.123c-0.005-1.801-1.475-3.26-3.275-3.254l-7.03,0.021 c-1.801,0.006-3.261,1.475-3.255,3.275L8.54,102.075z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M133.776,101.672l-0.411,0.002l-0.029-9.232c-0.007-2.027,1.638-3.684,3.665-3.689l7.029-0.021 c2.027-0.008,3.682,1.637,3.688,3.664l0.029,9.123l-0.411,0.002l-0.029-9.123c-0.006-1.801-1.475-3.262-3.275-3.256l-7.03,0.023 c-1.801,0.006-3.261,1.475-3.255,3.275L133.776,101.672z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#E6A9A2",
    d: "M61.297,80.538l0.28-1.289c0,0-0.047-0.537-0.28-0.432c-0.233,0.104-0.378,1.225-0.645,1.512 C60.387,80.614,61.113,80.799,61.297,80.538z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#E6A9A2",
    points: "51.189,70.25 53.809,73.608 60.908,80.926 59.018,83.768 49.734,76.557 47.85,73.608  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "50.803,96.118 61.577,79.92 52.163,73.073 44.062,87.145  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6A9A2",
    d: "M44.507,122.215c-0.074-0.096,0.342-3.42,0.342-4.482c0-1.064,3.951-0.191,3.951-0.191 s-0.076,3.496,0.19,4.293C49.256,122.633,45.343,123.278,44.507,122.215z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6A9A2",
    d: "M16.61,72.073c0,0-2.888,5.699-2.66,6.687c0.228,0.986,10.534,7.377,10.534,7.377l0.825-3.047 l-5.281-5.547l2.052-3.281L16.61,72.073z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6A9A2",
    d: "M34.998,67.135l-4.634-9.019c0,0,0.364-0.505,0.713-1.458c0.116-0.316,0.23-0.681,0.331-1.092 c0.015-0.061,0.035-0.116,0.062-0.166c0.672-1.297,4.982,1.134,5.75,1.134c0.798,0,0.514,1.709,1.083,2.621 C38.873,60.068,34.998,67.135,34.998,67.135z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#06065C",
    d: "M51.524,69.3c0,1.596-4.104,4.64-4.104,4.64l-3.647-2.93l-0.797,17.665 c-2.28,4.104-17.78,0.57-17.78,0.57c2.051-8.891-0.456-18.122-0.456-18.122l-2.233,3.655c-1.481,0.684-6.337-2.705-6.337-2.705 s3.67-8.473,5.265-10.637c1.117-1.516,4.975-2.661,7.185-3.21c0.946-0.236,1.592-0.362,1.592-0.362l4.787,7.827l3.077-7.219 c0,0,0.711,0.237,1.678,0.577c1.875,0.661,4.709,1.708,5.16,2.159C45.598,61.892,51.524,69.3,51.524,69.3z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#E6A9A2",
    d: "M33.649,122.258c0,0,0.035-2.939-0.347-4.158c-0.382-1.217,3.086-1.391,3.606-1.426 c0.521-0.033,0.833,0.73,0.868,1.371c0.034,0.641,0.243,3.068,0.416,4.213S34.169,123.647,33.649,122.258z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EAAC50",
    d: "M37.291,130.27c-0.673,0.82-2.927,1.07-3.928,0.316c-0.185-0.139-0.326-0.312-0.407-0.523 c-0.062-0.164-0.108-0.375-0.142-0.625c-0.045-0.336-0.066-0.738-0.07-1.182c-0.016-1.947,0.303-4.652,0.366-5.721 c0,0-0.225-1.215,0.539-1.318c0.763-0.104,3.052-0.104,3.468,0c0.417,0.104,0.417,1.006,0.59,1.006s0.417-0.52,0.451-0.729 c0.035-0.207,0.486,1.229,0.486,1.689c0,0.119,0.011,0.289,0.03,0.479c0.052,0.545,0.161,1.258,0.212,1.41 C38.956,125.276,38.089,129.299,37.291,130.27z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#010060",
    d: "M36.882,124.209c-1.621-1.049-3.538-0.145-3.557-0.137l-0.044-0.092c0.02-0.01,1.987-0.938,3.657,0.143 L36.882,124.209z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#010060",
    d: "M36.689,125.413c-1.621-1.049-3.538-0.145-3.557-0.135l-0.044-0.092c0.02-0.01,1.988-0.939,3.657,0.141 L36.689,125.413z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#010060",
    d: "M36.689,126.618c-1.622-1.049-3.538-0.145-3.557-0.137l-0.044-0.092c0.02-0.01,1.988-0.939,3.657,0.143 L36.689,126.618z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#06065C",
    d: "M37.291,130.27c-0.673,0.82-2.927,1.07-3.928,0.316c-0.022-0.018-0.045-0.035-0.066-0.055 c-0.019-0.014-0.035-0.029-0.051-0.045c-0.017-0.016-0.032-0.031-0.046-0.045c-0.011-0.012-0.022-0.023-0.033-0.037 c-0.02-0.02-0.037-0.041-0.053-0.064c-0.015-0.018-0.029-0.037-0.041-0.057c-0.011-0.014-0.021-0.029-0.03-0.045 s-0.019-0.033-0.027-0.049c-0.003-0.004-0.005-0.008-0.006-0.01c-0.01-0.018-0.019-0.037-0.027-0.055 c-0.01-0.021-0.019-0.041-0.027-0.062c-0.062-0.164-0.108-0.375-0.142-0.625c0.489,0.441,1.591,1.197,3.002,0.693 c0.526-0.188,0.994-0.838,1.395-1.686c0.698-1.467,1.197-3.523,1.463-4.783c0.052,0.545,0.161,1.258,0.212,1.41 C38.956,125.276,38.089,129.299,37.291,130.27z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E54750",
    d: "M37.21,128.446c-0.401,0.848-0.869,1.498-1.395,1.686c-1.411,0.504-2.513-0.252-3.002-0.693 c-0.045-0.336-0.066-0.738-0.07-1.182C33.492,127.77,35.256,126.963,37.21,128.446z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#E6A9A2",
    d: "M39.95,50.645c-0.027,0.738-0.126,1.449-0.274,2.116c-0.082,0.372-0.18,0.731-0.289,1.074 c-0.519,1.653-1.289,2.942-1.83,3.591c-0.257,0.309-0.732,0.441-1.306,0.439c-1.334-0.007-3.21-0.748-4.165-1.727 c-0.283-0.29-0.554-0.631-0.806-1.013c-0.967-1.458-1.66-3.483-1.719-5.336c-0.057-1.792,0.385-3.382,0.595-4.026 c0.066-0.205,0.161-0.398,0.281-0.576c2.468-3.643,6.464-2.051,7.689-1.439C39.38,44.375,40.064,47.51,39.95,50.645z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E54750",
    d: "M43.431,88.084c-3.019-1.387-5.641,2.662-10.58,0.566c-0.388-0.273-0.72-0.469-0.962-0.566 c-1.564-0.641-5.439-0.32-6.693,1.064c0,0-2.564,3.461,0,6.498c2.253,2.666,4.559,3.408,4.559,3.408l2.81,20.424 c0,0,2.433,1.945,5.472-0.008c0,0,0.45-17.359,0.59-22.004c1.882,1.219,3.969,1.41,3.969,1.41l1.609,20.586 c0,0,2.72,2.137,5.077-0.42c0,0,0.646-18.854,0.76-22.367C50.156,93.161,44.963,88.786,43.431,88.084z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EAAC50",
    d: "M55.782,127.643c-0.277,0.66-1.374,1.279-2.688,1.182c-1.912-0.141-7.908-2.008-9.399-2.99 c-0.157-0.104-0.246-0.283-0.231-0.471c0.018-0.234,0.048-0.6,0.092-1.016c0.116-1.098,0.326-2.541,0.648-2.818 c0.532-0.455,1.14,0.838,1.899,0.838s0.912-0.879,1.52-0.934s1.368-0.479,1.976,0c0.443,0.346,2.614,2.533,4.262,3.99 c0.617,0.547,1.161,0.99,1.513,1.197c0.267,0.158,0.415,0.35,0.461,0.557C55.869,127.329,55.848,127.487,55.782,127.643z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#06065C",
    d: "M55.845,127.413c-0.002,0.023-0.007,0.049-0.013,0.072c-0.005,0.025-0.012,0.053-0.021,0.08 c-0.008,0.025-0.018,0.051-0.029,0.078c-0.277,0.66-1.374,1.279-2.688,1.182c-1.912-0.141-7.908-2.008-9.399-2.99 c-0.157-0.104-0.246-0.283-0.231-0.471c0.018-0.234,0.048-0.6,0.092-1.016c0.571,0.387,3.688,2.402,7.315,3.072 c0.47,0.086,0.899,0.15,1.294,0.195c2.067,0.236,3.14-0.053,3.669-0.438C55.852,127.254,55.855,127.334,55.845,127.413z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#010060",
    d: "M47.467,124.114l-0.087-0.055c1.231-1.977,3.637-1.344,3.661-1.336l-0.027,0.1 C50.99,122.817,48.657,122.204,47.467,124.114z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#010060",
    d: "M48.804,124.915l-0.083-0.061c1.315-1.803,3.052-1.416,3.069-1.412l-0.023,0.1 C51.75,123.54,50.078,123.168,48.804,124.915z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#010060",
    d: "M50.314,125.624l-0.087-0.055c0.741-1.201,2.151-1.529,2.166-1.533l0.022,0.1 C52.401,124.139,51.032,124.459,50.314,125.624z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E54750",
    d: "M55.851,127.188c-0.529,0.387-1.602,0.676-3.669,0.439c0.521-1.59,1.298-2.057,1.696-2.191 c0.617,0.547,1.161,0.99,1.513,1.197C55.657,126.792,55.805,126.983,55.851,127.188z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M39.753,59.049l-3.844,8.085h-1.546l-5.743-8.908c0.946-0.236,1.592-0.362,1.592-0.362l4.787,7.827 l3.077-7.219C38.075,58.473,38.787,58.71,39.753,59.049z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#06065C",
    d: "M40.583,43.2c0.513-1.026-1.541-2.388-2.906-1.254c-1.365,1.135-2.963-0.228-4.73,0.228 c-1.767,0.456-2.621,1.595-3.829,3.419c-1.168,1.767,0.808,6.497,0.808,6.497s-0.325-2.809,1.083-3.021 c0.681-0.103,0.494,0.437,0.494,0.437s0.323,1.748,0.038,2.773c-0.285,1.025,1.292,1.349,1.463,0.551 c0.171-0.798,0.171-3.362,0.912-4.103s2.906-0.114,4.046-0.285c0.271-0.041,0.539-0.078,0.795-0.129 c0.354-0.071,0.716,0.093,0.895,0.407c0.176,0.311,0.324,0.709,0.312,1.166c0,0,0.24,0,0.316-0.646 c0.044-0.373-0.068-1.049-0.171-1.555c0.202-0.206,0.364-0.476,0.475-0.839C40.981,45.537,40.07,44.226,40.583,43.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#06065C",
    d: "M36.251,57.865c0,0-2.027,0.387-3.647-0.342c-0.672-0.302-1.172-0.609-1.526-0.864 c0.116-0.316,0.23-0.681,0.331-1.092c0.015-0.061,0.035-0.116,0.062-0.166c0.197,0.271,0.402,0.52,0.616,0.737 C33.041,57.117,34.917,57.858,36.251,57.865z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#06065C",
    points: "24.74,71.123 25.804,68.882 25.272,73.608  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#06065C",
    points: "43.773,71.01 42.444,68.427 43.584,73.608  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M16.876,69.528c0,0,3.067,2.498,6.805,3.328l-1.448,2.484c0,0-5.3-1.576-6.326-3.267L16.876,69.528z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M45.635,72.506c0,0,3.879-3.513,4.409-5.05l1.898,2.072c0,0-0.228,2.211-4.635,4.734L45.635,72.506z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "37.05,70.25 37.05,75.34 39.962,76.557 41.912,75.34 41.912,70.25  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M18.785,70.27l-0.095-0.04c0.382-0.923,3.753-9.027,4.442-9.202c0.674-0.171,5.974-1.969,6.027-1.987 l0.033,0.097c-0.054,0.018-5.357,1.818-6.035,1.989C22.674,61.249,20.278,66.661,18.785,70.27z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M49.695,68.097c-0.044-0.053-4.412-5.347-5.163-6.248c-0.741-0.889-5.022-2.166-5.065-2.178l0.029-0.1 c0.177,0.053,4.354,1.299,5.115,2.211c0.751,0.902,5.119,6.195,5.163,6.249L49.695,68.097z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#06065C",
    d: "M37.049,54.592v-0.103c0.008,0,0.83-0.004,1.04-0.319c0.179-0.268,0.055-1.835-0.008-2.416l0.102-0.011 c0.023,0.218,0.223,2.137-0.008,2.484C37.935,54.588,37.085,54.592,37.049,54.592z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E54750",
    d: "M34.884,52.556c-0.868,0-0.869,1.349,0,1.349C35.752,53.904,35.753,52.556,34.884,52.556z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E54750",
    d: "M39.676,52.761c-0.082,0.372-0.18,0.731-0.289,1.074C39.13,53.497,39.227,52.908,39.676,52.761z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "23.515,87.493 29.393,94.936 50.803,94.588 44.062,87.145  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    fill: "#D69B52",
    cx: 37.049,
    cy: 90.659,
    rx: 9.628,
    ry: 3.512
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#E54750",
    cx: 37.049,
    cy: 90.659,
    rx: 8.78,
    ry: 3.203
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#D69B52",
    cx: 37.05,
    cy: 90.659,
    rx: 8.011,
    ry: 2.922
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M30.796,89.385c-0.136,0.018-0.265,0.074-0.372,0.16c-0.179,0.145-0.429,0.381-0.321,0.512 c0.161,0.197,0.554-0.107,0.644,0s-0.089,0.357,0.125,0.43c0.215,0.072,0.483-0.125,0.447-0.455 c-0.036-0.332,0.625-0.117,0.304-0.457C31.413,89.352,31.033,89.356,30.796,89.385z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6DBDAD",
    d: "M32.446,89.04c0,0,0.393-0.697,1.126-0.395C34.305,88.95,32.446,89.04,32.446,89.04z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#E54750",
    cx: 33.465,
    cy: 92.149,
    rx: 1.019,
    ry: 0.475
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#E54750",
    cx: 38.523,
    cy: 91.487,
    rx: 1.019,
    ry: 0.475
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#E54750",
    cx: 41.981,
    cy: 89.04,
    rx: 0.807,
    ry: 0.375
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#E54750",
    cx: 42.118,
    cy: 91.559,
    rx: 1.019,
    ry: 0.473
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#E54750",
    cx: 36.968,
    cy: 88.475,
    rx: 1.019,
    ry: 0.475
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#06065C",
    cx: 32.49,
    cy: 90.567,
    rx: 0.474,
    ry: 0.188
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#06065C",
    cx: 37.987,
    cy: 92.811,
    rx: 0.474,
    ry: 0.188
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#06065C",
    cx: 34.958,
    cy: 88.475,
    rx: 0.474,
    ry: 0.188
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#06065C",
    cx: 38.264,
    cy: 89.792,
    rx: 0.474,
    ry: 0.188
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#06065C",
    cx: 42.118,
    cy: 90.243,
    rx: 0.474,
    ry: 0.188
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M33.743,90.04c0,0,0.79-0.035,0.897-0.25c0.107-0.215-0.21-0.203,0.094-0.34 c0.304-0.137,0.804-0.027,0.858,0.486c0.054,0.516-0.789,0.816-0.84,0.631C34.64,90.165,33.414,90.415,33.743,90.04z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6DBDAD",
    d: "M30.45,90.969c-0.19,0.01-0.326,0.201-0.262,0.381c0.063,0.182,0.243,0.396,0.707,0.531 c0.925,0.268,0.925,0.268,0.925,0.268S31.318,90.926,30.45,90.969z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M36.4,91.532c-0.13-0.049-0.271-0.057-0.406-0.027c-0.316,0.07-0.961,0.246-0.92,0.502 c0.054,0.34,0.59-0.107,0.715,0.143c0.125,0.252-0.054,0.697,0.268,0.787s0.608-0.303,0.357-0.662 c-0.25-0.357,0.555-0.143,0.375-0.445C36.699,91.672,36.537,91.583,36.4,91.532z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6DBDAD",
    d: "M36.128,90.622c0,0,0.787-0.939,1.288-0.545C37.917,90.469,36.128,90.622,36.128,90.622z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6DBDAD",
    d: "M40.67,91.676c0,0-1.26,0.258-1.287,0.66s0.885,0.322,1.099,0C40.697,92.016,40.67,91.676,40.67,91.676z "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6DBDAD",
    d: "M44.425,90.034c0,0-1.26,0.26-1.287,0.662s0.885,0.322,1.1,0C44.452,90.374,44.425,90.034,44.425,90.034 z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M39.382,88.288c0,0-0.669-0.08-0.643,0.188c0.027,0.27,0.723,0.146,0.643,0.328 c-0.08,0.182-0.37,0.316-0.318,0.477c0.051,0.162,0.614,0.402,0.667,0c0.054-0.402,0.269-0.488,0.483-0.391 c0.214,0.096,0.563-0.039,0.322-0.32C40.294,88.288,39.382,88.288,39.382,88.288z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6DBDAD",
    d: "M39.382,90.379c0,0,1.319-0.832,1.559-0.188S39.382,90.379,39.382,90.379z"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "23.515,87.493 23.515,89.372 29.176,96.465 50.803,96.118 50.803,94.588 29.393,94.936  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#06065C",
    points: "50.846,96.145 50.76,96.088 61.507,79.934 60.667,79.323 50.831,94.639 50.804,94.639  29.368,94.987 23.566,87.641 23.566,89.354 24.583,90.627 24.502,90.692 23.463,89.389 23.463,87.344 29.417,94.883  50.774,94.538 60.639,79.174 61.647,79.909  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#06065C",
    d: "M45.074,88.081l-1.078-0.924l8.151-14.158l1.208,0.877l-0.023,0.041L45.074,88.081z M44.127,87.135 l0.92,0.787l8.172-14.018l-1.04-0.756L44.127,87.135z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.416,
    y: 76.517,
    transform: "matrix(0.8087 0.5882 -0.5882 0.8087 55.9364 -18.8632)",
    fill: "#06065C",
    width: 9.108,
    height: 0.103
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6A9A2",
    d: "M32.18,85.887c-0.042-0.273-1.659-0.607-1.659-0.607l-1.174-0.344c-0.001-0.012-0.001-0.023-0.002-0.035 c0.73,0.189,2.052,0.516,2.248,0.449c0.273-0.09,0.455-0.121,0.414-0.395c-0.042-0.273-1.659-0.605-1.659-0.605l-1.51-0.443 c-0.266-0.158-0.627-0.289-1.016-0.396c0.423-0.467,1.568-0.311,1.928-0.42c0.373-0.113,0.669-0.303,0.423-0.512 c-0.203-0.172-1.766-0.18-2.312-0.176c-0.123,0-0.244,0.021-0.36,0.061l-1.909,0.65c-0.149-0.016-0.238-0.023-0.238-0.023 c-1.709,0.076-1.026,2.963-1.026,2.963s1.736,0.961,3.29,1.133c0.142,0.016,0.282,0.047,0.421,0.084 c0.632,0.166,2.261,0.582,2.48,0.51c0.273-0.092,0.456-0.123,0.414-0.395c-0.042-0.273-1.659-0.607-1.659-0.607l-0.325-0.096 c0.019-0.027,0.038-0.055,0.056-0.082c0.741,0.189,1.987,0.494,2.177,0.43c0.273-0.09,0.455-0.121,0.414-0.395 s-1.659-0.605-1.659-0.605l-0.647-0.189c0.004-0.021,0.008-0.043,0.012-0.064c0.642,0.168,2.249,0.578,2.467,0.506 C32.039,86.19,32.221,86.159,32.18,85.887z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6A9A2",
    d: "M61.458,80.674c-0.069-0.062-0.586-0.512-0.922-0.65c-0.361-0.148-0.477-0.619-0.748-0.439 c-0.464,0.307,0.101,0.855,0.101,0.855l1.011,0.84l-0.045,0.064c-0.159-0.137-0.578-0.482-0.865-0.602 c-0.361-0.148-0.477-0.619-0.748-0.439c-0.464,0.309,0.101,0.855,0.101,0.855l1.031,0.857l-0.029,0.039 c-0.18-0.15-0.562-0.459-0.83-0.57c-0.361-0.148-0.477-0.619-0.748-0.439c-0.464,0.307,0.1,0.855,0.1,0.855l0.996,0.826 l-0.037,0.051c-0.192-0.152-0.442-0.332-0.634-0.41c-0.361-0.148-0.477-0.619-0.748-0.439c-0.464,0.307,0.101,0.854,0.101,0.854 l0.889,0.74c0.026,0.045,0.068,0.092,0.139,0.115l0.019,0.016c0.003-0.004,0.006-0.006,0.009-0.008 c0.137,0.029,0.365-0.02,0.746-0.266C61.271,82.78,62.296,81.413,61.458,80.674z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#06065C",
    d: "M20.029,77.543c0,0-1.603-0.248-2.68,0.238c0,0,2.233-0.037,3.219,0.328L20.029,77.543z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.513,
    y: 70.757,
    fill: "#06065C",
    width: 4.131,
    height: 0.205
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#06065C",
    points: "50.044,96.129 29.039,97.038 25.727,92.143 29.176,96.465  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34.334,
    y: 107.129,
    transform: "matrix(0.0561 0.9984 -0.9984 0.0561 149.7444 56.0668)",
    fill: "#FFFFFF",
    width: 21.771,
    height: 0.206
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22.137,
    y: 107.407,
    transform: "matrix(0.1003 0.995 -0.995 0.1003 136.4589 64.1112)",
    fill: "#FFFFFF",
    width: 21.285,
    height: 0.206
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#06065C",
    points: "42.118,98.807 43.773,97.454 42.596,98.877  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#06065C",
    points: "29.039,98.747 30.487,97.454 29.755,99.055  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M39.522,47.43l-0.081-0.063c0.399-0.507,0.469-1.476,0.185-2.59c-0.266-1.043,0.074-2.375,0.077-2.389 l0.1,0.026c-0.003,0.013-0.336,1.32-0.077,2.337C40.017,45.896,39.941,46.897,39.522,47.43z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#70C6C1",
    d: "M90.065,97.479c0,0,5.352,3.344,17.17,2.117c0,0,1.486-5.885-6.789-6.344 C92.17,92.795,90.734,93.911,90.065,97.479z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#E6A9A2",
    d: "M102.553,92.942c0,0-1.761,1.656-2.106,3.691c-0.347,2.037,0.607,3.609,0.545,4.998 c-0.061,1.387-0.285,17.963-2.182,21.57c-0.32,0.77-1.637,2.23-1.637,2.23c0.662,1.531,4.842,0.975,4.807,0 c-0.035-0.977,0.418-2.504,0.418-2.504s3.537-9.916,4.244-12.137c0.705-2.221,1.486-7.031,0.482-11.658 c0,0-0.446-1.48,1.17-1.943C109.911,96.727,109.019,92.12,102.553,92.942z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6A9A2",
    d: "M103.444,94.194c-0.643-1.283-9.773-1.35-11.274,0.371c0,0-2.103,1.09-2.104,2.914 c-0.002,2.064,0.865,3.797,0.805,5.186c-0.062,1.387,0.015,16.268-1.881,19.877c-0.181,0.389-1.554,1.715-1.554,1.715 c-0.204,1.115,4.54,1.105,4.54,0.285c0-0.822,0.455-1.982,0.455-1.982s3.382-8.514,4.088-10.734s1.486-7.033,0.482-11.658 c0,0-0.445-1.48,1.172-1.943l4.156-0.686C102.329,97.538,104.226,95.756,103.444,94.194z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#06065C",
    d: "M102.501,127.295c0,0.836-6.32,3.037-9.664,1.309c0,0-0.061-0.297,0.062-0.688 c0.129-0.412,0.465-0.926,1.296-1.301c1.62-0.73,3.03-1.463,3.03-1.463s0.731,0.418,2.352,0.576 c1.619,0.156,2.245-0.889,2.507-0.576c0.182,0.219,0.313,0.766,0.376,1.361C102.487,126.772,102.501,127.042,102.501,127.295z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E54750",
    d: "M102.501,127.295c0,0.836-6.32,3.037-9.664,1.309c0,0-0.061-0.297,0.062-0.688 c0.289,0.168,0.943,0.418,2.393,0.58c1.996,0.221,5.854-1.309,7.168-1.982C102.487,126.772,102.501,127.042,102.501,127.295z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E54750",
    d: "M98.343,126.264c-0.633-0.508-1.934-0.643-1.946-0.645l0.011-0.102c0.055,0.004,1.343,0.141,2,0.666 L98.343,126.264z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E54750",
    d: "M97.771,126.557c-0.559-0.379-2.032-0.607-2.047-0.609l0.016-0.104c0.062,0.01,1.511,0.236,2.089,0.627 L97.771,126.557z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E54750",
    d: "M97.356,126.944c-0.346-0.277-2.264-0.684-2.283-0.688l0.021-0.102c0.08,0.018,1.961,0.416,2.326,0.707 L97.356,126.944z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#06065C",
    d: "M92.413,126.03c0.001,0.596-0.029,1.117-0.029,1.117s-4.878,0.939-5.854,0.904 c-0.975-0.033-3.656,0.176-3.727-0.904c0,0-0.008-0.182,0.123-0.428c0.146-0.275,0.467-0.633,1.166-0.904 c1.324-0.514,3.343-1.559,3.343-1.559s0.905,0.369,2.159,0.498s2.299-0.811,2.612-0.359 C92.37,124.633,92.412,125.375,92.413,126.03z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E54750",
    d: "M92.413,126.03c0.001,0.596-0.029,1.117-0.029,1.117s-4.878,0.939-5.854,0.904 c-0.975-0.033-3.656,0.176-3.727-0.904c0,0-0.008-0.182,0.123-0.428c0.223,0.164,0.814,0.465,2.28,0.637 C86.978,127.563,91.174,126.391,92.413,126.03z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E54750",
    d: "M87.124,125.864c-0.297-0.531-1.516-0.719-1.527-0.721l0.016-0.102 c0.051,0.008,1.279,0.197,1.602,0.773L87.124,125.864z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E54750",
    d: "M87.563,125.606c-0.298-0.533-1.332-0.723-1.342-0.725l0.018-0.102 c0.045,0.008,1.092,0.201,1.414,0.775L87.563,125.606z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#E54750",
    d: "M88.021,125.317c-0.298-0.533-1.331-0.723-1.342-0.725l0.018-0.102 c0.045,0.008,1.093,0.201,1.414,0.775L88.021,125.317z"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "#06065C",
    d: "M122.622,85.772c-5.464-2.23-16.391-0.111-17.506-0.043c-1.117,0.068-9.811,4.279-12.946,7.066 s-2.104,4.684-2.104,4.684c1.672-4.572,5.463-4.236,11.818-3.234c2.068,0.328,3.357,1.008,4.155,1.779l0,0h3.448l-2.633,1.092 c0.656,1.283,0.381,2.48,0.381,2.48s5.686-1.336,8.809-2.117c3.121-0.781,6.467-2.008,7.135-4.227 C123.849,91.036,122.622,85.772,122.622,85.772z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6A9A2",
    d: "M119.521,57.459c0,0,2.497-0.118,3.857,0.551c1.361,0.669,3.74,6.616,4.112,7.582 s2.974,6.765,3.048,7.432c0.074,0.67,0.371,1.338-0.67,3.049c-1.04,1.709-6.777,5.928-6.777,5.928l-1.324-2.139 c0,0,4.758-6.541,4.758-6.764c0-0.222-5.055-9.068-5.055-9.068s-1.646,5.947-2.012,6.987c-0.367,1.041-2.076-6.987-1.854-8.176 C117.827,61.652,119.521,57.459,119.521,57.459z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6A9A2",
    d: "M108.907,58.01c0,0,2.008-0.297,2.453-1.784c0.446-1.486,0-2.601,0-2.601s4.237-0.446,4.758-1.041 c0,0,1.652,4.379,2.453,4.866c0,0-1.115,6.803-4.237,8.439c-3.122,1.635-5.166,1.635-6.04-0.67 C107.421,62.916,108.907,58.01,108.907,58.01z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6A9A2",
    d: "M108.294,58.01c0,0-3.771,0.297-4.589,2.899s-4.015,11.298-4.237,11.967l-6.838,1.859 c0,0,0.562,1.891,0.637,2.412c0,0,7.613-0.184,8.58-1c0.967-0.818,4.459-7.656,4.459-7.656L108.294,58.01z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E54750",
    d: "M104.894,86.887c0,0,1.562-8.25,2.008-9.59c0.445-1.338-2.414-8.366-2.008-9.921 c0.52-1.99,3.011-7.917,3.011-9.366l1.425-0.097c0,0-2.205,6.676,0.024,8.125s5.966-1.395,7.08-4.07 c1.114-2.675,1.845-4.81,1.845-4.81l1.242,0.301c0,0-2.139,6.015-0.689,9.694c0.181,0.459,1.486,1.34,1.505,1.84 c0.093,2.504-1.575,6.982-1.282,8.64c0.334,1.895,3.568,8.139,3.568,8.139S113.702,88.559,104.894,86.887z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#06065C",
    d: "M108.02,44.928c0,0-1.267,2.378-1.342,3.791c-0.074,1.412,0.595,2.081,0,3.567 c-0.595,1.487-0.037,2.305,1.616,2.602c1.654,0.297,2.844-0.595,3.066-1.71c0.223-1.115-1.709-6.913-1.115-7.879 C110.841,44.333,108.02,44.928,108.02,44.928z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6A9A2",
    d: "M116.118,52.584c-0.221,0.271-0.512,0.515-0.85,0.728c-0.938,0.597-2.211,0.963-3.168,1.037 c-0.004,0-0.004,0-0.004,0c-0.207,0.017-0.399,0.02-0.57,0.008c-1.246-0.087-2.247-1.847-2.915-4.597 c-0.67-2.75-0.317-5.947-0.317-5.947c0.725-2.75,4.256-4.088,7.378-2.825c3.121,1.265,2.824,4.089,2.899,5.5 C118.645,47.902,117.085,51.395,116.118,52.584z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "96.192,88.487 112.194,91.655 120.181,85.709 104.076,83.208  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#D79C52",
    d: "M108.02,84.7c-2.017,0-3.846,0.291-5.188,0.766l0.388,0.197c1.23-0.447,2.927-0.725,4.801-0.725 c3.759,0,6.806,1.111,6.806,2.482c0,1.373-3.047,2.484-6.806,2.484c-3.307,0-6.062-0.861-6.677-2.002l-0.592,0.135 c0.766,1.207,3.728,2.105,7.269,2.105c4.122,0,7.464-1.219,7.464-2.723C115.483,85.918,112.142,84.7,108.02,84.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E54750",
    d: "M108.02,85.157c3.43,0,6.21,1.014,6.21,2.264c0,1.252-2.78,2.266-6.21,2.266 c-3.095,0-5.66-0.826-6.132-1.906l-0.545,0.123c0.615,1.141,3.37,2.002,6.677,2.002c3.759,0,6.806-1.111,6.806-2.484 c0-1.371-3.047-2.482-6.806-2.482c-1.874,0-3.57,0.277-4.801,0.725l0.354,0.178C104.7,85.418,106.276,85.157,108.02,85.157z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D79C52",
    d: "M108.02,89.686c3.43,0,6.21-1.014,6.21-2.266c0-1.25-2.78-2.264-6.21-2.264 c-1.743,0-3.319,0.262-4.446,0.684l2.129,1.078l-3.814,0.861C102.359,88.86,104.925,89.686,108.02,89.686z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#6DBEAE",
    d: "M104.451,86.165c0,0,0.305-0.541,0.873-0.305C105.892,86.096,104.451,86.165,104.451,86.165z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#E54750",
    cx: 105.241,
    cy: 88.577,
    rx: 0.79,
    ry: 0.367
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#E54750",
    cx: 109.162,
    cy: 88.063,
    rx: 0.79,
    ry: 0.367
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#E54750",
    cx: 111.842,
    cy: 86.165,
    rx: 0.625,
    ry: 0.291
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#E54750",
    cx: 111.949,
    cy: 88.118,
    rx: 0.79,
    ry: 0.369
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#E54750",
    cx: 107.956,
    cy: 85.729,
    rx: 0.79,
    ry: 0.367
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#06065C",
    cx: 104.485,
    cy: 87.35,
    rx: 0.367,
    ry: 0.146
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#06065C",
    cx: 108.746,
    cy: 89.09,
    rx: 0.367,
    ry: 0.145
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#06065C",
    cx: 106.397,
    cy: 85.729,
    rx: 0.367,
    ry: 0.145
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#06065C",
    cx: 108.962,
    cy: 86.749,
    rx: 0.367,
    ry: 0.146
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#06065C",
    cx: 111.948,
    cy: 87.098,
    rx: 0.367,
    ry: 0.145
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M105.457,86.942c0,0,0.612-0.027,0.694-0.195c0.084-0.166-0.162-0.156,0.073-0.264 c0.235-0.105,0.624-0.02,0.665,0.379c0.042,0.398-0.611,0.633-0.65,0.488C106.151,87.038,105.201,87.233,105.457,86.942z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6DBEAE",
    d: "M102.903,87.661c-0.146,0.008-0.252,0.156-0.203,0.295c0.05,0.143,0.188,0.309,0.549,0.414 c0.717,0.207,0.717,0.207,0.717,0.207S103.577,87.627,102.903,87.661z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M107.517,88.098c-0.101-0.039-0.21-0.045-0.314-0.021c-0.246,0.055-0.746,0.189-0.714,0.389 c0.042,0.264,0.457-0.082,0.554,0.111c0.098,0.193-0.041,0.541,0.209,0.609c0.249,0.07,0.471-0.234,0.277-0.512 c-0.195-0.277,0.43-0.111,0.291-0.348C107.747,88.206,107.622,88.137,107.517,88.098z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6DBEAE",
    d: "M107.306,87.393c0,0,0.61-0.729,0.998-0.424C108.692,87.274,107.306,87.393,107.306,87.393z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6DBEAE",
    d: "M110.826,88.209c0,0-0.978,0.201-0.998,0.512c-0.021,0.312,0.687,0.25,0.853,0 C110.847,88.473,110.826,88.209,110.826,88.209z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6DBEAE",
    d: "M113.737,86.938c0,0-0.978,0.199-0.998,0.512c-0.021,0.312,0.686,0.25,0.852,0 C113.758,87.2,113.737,86.938,113.737,86.938z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M109.827,85.583c0,0-0.519-0.062-0.498,0.146c0.021,0.207,0.561,0.113,0.498,0.254 c-0.061,0.141-0.286,0.244-0.246,0.369c0.039,0.125,0.477,0.312,0.518,0s0.207-0.379,0.374-0.303 c0.167,0.074,0.437-0.031,0.249-0.248C110.535,85.583,109.827,85.583,109.827,85.583z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6DBEAE",
    d: "M109.827,87.204c0,0,1.023-0.643,1.209-0.145S109.827,87.204,109.827,87.204z"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "96.192,88.487 96.192,89.905 112.315,92.844 120.181,86.749 120.181,85.709 112.194,91.655  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "112.315,92.844 121.841,99.411 128.51,92.633 120.181,86.749  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#06065C",
    d: "M112.206,91.709l-16.146-3.197l8.004-5.359l0.021,0.004l16.225,2.521L112.206,91.709z M96.324,88.459 l15.856,3.141l7.871-5.859l-15.963-2.479L96.324,88.459z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#06065C",
    d: "M121.847,99.479l-9.551-6.586l-16.154-2.945v-1.461h0.102v1.375l16.06,2.928l7.876-6.105l0.031,0.023 l8.379,5.918l-0.043,0.045L121.847,99.479z M112.403,92.842l9.432,6.502l6.596-6.703l-8.249-5.828L112.403,92.842z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#06065C",
    d: "M108.981,40.915c0,0-1.309-0.109-2.353,1.858c-1.017,1.914,0.718,3.345,2.353,3.642 c1.636,0.297,2.305-1.115,3.865-0.669c1.562,0.446,1.487,1.933,2.156,2.155c0.669,0.223,0.967,2.825,0.297,4.683 c-0.668,1.858,0.453,2.673,1.936,2.674c1.484,0.001,3.119-0.147,3.49-1.783c0.372-1.635-1.709-3.197-0.742-5.39 c0.966-2.192-1.562-7.32-4.163-7.915S111.36,40.246,108.981,40.915z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#06065C",
    d: "M115.485,53.774c-1.301,0.759-3.279,0.585-3.385,0.575c0.957-0.074,2.23-0.44,3.168-1.037L115.485,53.774 z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#06065C",
    d: "M110.582,51.587c-0.134,0-0.282-0.021-0.382-0.093c-0.069-0.05-0.108-0.12-0.117-0.206 c-0.037-0.374,0.248-2.203,0.26-2.28l0.103,0.016c-0.003,0.019-0.296,1.893-0.261,2.254c0.006,0.057,0.031,0.1,0.076,0.133 c0.18,0.132,0.602,0.046,0.606,0.045l0.021,0.101C110.878,51.559,110.741,51.587,110.582,51.587z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E54750",
    d: "M113.145,49.769c-0.345,0-0.676,0.303-0.659,0.66c0.016,0.357,0.289,0.66,0.659,0.66 c0.345,0,0.676-0.303,0.659-0.66C113.788,50.071,113.515,49.769,113.145,49.769z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#06065C",
    d: "M115.435,72.68c-2.643,0.001-3.789-1.571-4.045-1.985c-0.741,1.902-4.09,1.461-4.234,1.441l0.015-0.102 c0.035,0.005,3.53,0.465,4.159-1.479l0.039-0.119l0.057,0.112c0.012,0.024,1.24,2.397,4.836,1.979l0.012,0.102 C115.978,72.664,115.698,72.68,115.435,72.68z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#06065C",
    d: "M99.468,72.876c0,0,1.39,0.82,1.875,1.73c0,0-0.494-1.547-1.594-2.521L99.468,72.876z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#06065C",
    d: "M126.524,73.098c0,0,1.449-0.194,2.619,0.248c0,0-2.31,0.033-3.078,0.488L126.524,73.098z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#06065C",
    points: "121.47,64.03 120.771,62.768 121.015,65.663  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6A9A2",
    d: "M92.63,74.735c0,0-0.432-0.041-1.026-0.076l-1.343-0.764c0,0-1.714-0.771-1.902-0.385 s0.625,0.414,0.971,0.637c0.184,0.119,0.334,0.309,0.436,0.461c-0.75,0.014-1.403,0.084-1.595,0.275 c-0.521,0.52,0.167,1.332,1.109,1.926c0.942,0.596,3.351,0.451,3.351,0.451S95.231,77.26,92.63,74.735z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6A9A2",
    d: "M90.958,76.481l-0.984-0.107c0.043-0.229-0.068-0.492-0.068-0.492L89.6,75.846 c0.093-0.164,0.036-0.396,0-0.506c0.028-0.008,0.05-0.018,0.061-0.033c0.145-0.193,0-0.531,0-0.531l-1.685-0.184 c0,0-1.438-0.426-1.459-0.086c-0.01,0.174,0.118,0.285,0.286,0.363c-0.394-0.064-0.776-0.08-0.787,0.105 c-0.012,0.195,0.132,0.32,0.321,0.41c-0.186,0.006-0.314,0.051-0.321,0.162c-0.021,0.332,0.372,0.482,0.726,0.58 c-0.021,0.451,0.663,0.588,1.074,0.697c0.414,0.111,2.949,0.629,3.143,0.369C91.151,76.936,90.958,76.481,90.958,76.481z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#EAAC50",
    d: "M91.616,79.098l-5.803-4.363l-0.371-0.279c2.453-1.968,3.958-1.6,3.958-1.6l0.179,0.502L91.616,79.098z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EAAC50",
    d: "M89.4,72.856c0,0,0.53-0.867-0.14-0.922c-0.668-0.055-3.289,0.67-4.292,1.785 c-1.003,1.115,0.474,0.736,0.474,0.736S88.258,72.604,89.4,72.856z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E54750",
    d: "M89.579,73.358c-0.342,0.246-1.182,0.139-1.656,0.139c-0.557,0-0.947,0.361-1.365,0.613 c-0.218,0.131-0.513,0.398-0.744,0.625l-0.371-0.279c2.453-1.968,3.958-1.6,3.958-1.6L89.579,73.358z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M87.733,74.11c0,0-0.721,0.387-0.624,0.625c0.2,0.49,0.545-0.039,0.624,0.268 c0.078,0.307-0.201,0.557,0.273,0.584c0.475,0.029-0.223-0.529,0-0.641S88.797,74.5,87.733,74.11z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E54750",
    d: "M89.968,74.456c0,0-1.292,0.156-0.902,0.881c0.391,0.725,1.365,0.42,1.365,0.42L89.968,74.456z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#06065C",
    d: "M89.146,74.284c0.186-0.225-0.133-0.518-0.354-0.326c-0.113,0.1-0.188,0.23-0.043,0.365 C88.888,74.454,89.049,74.401,89.146,74.284z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6DBEAE",
    d: "M88.936,76.145c0,0-0.084,0.621,0.776,0.967C89.712,77.112,89.892,76.34,88.936,76.145z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M89.917,77.821c0,0-0.089-0.598,0.246-0.58c0.334,0.02-0.022,0.566,0.268,0.58 c0.289,0.016,0.233-0.412,0.42-0.209c0.186,0.205,0.186,0.465,0,0.539c-0.187,0.074-0.402,0.068-0.402,0.068L89.917,77.821z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6DBEAE",
    d: "M86.176,75.006c0,0,0.114-0.334,0.53-0.367c0,0,0.071,0.246-0.15,0.652L86.176,75.006z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#E6A9A2",
    d: "M120.615,81.393l-2.54,1.35c0,0-1.553,0.42-1.512,0.881c0.042,0.463,2.393-0.697,3.022-0.697 c0.798,0,1.325-0.869,1.325-0.869L120.615,81.393z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6A9A2",
    d: "M123.378,81.786c0,0-0.125-1.197-1.611-1.924c0,0-0.174,0.07-0.436,0.188l0,0l-1.069-0.188 c0,0-2.118,0.094-2.192,0.447s0.39,0.398,0.742,0.33c0.227-0.045,0.723,0.016,1.111,0.133c-0.361,0.221-0.674,0.455-0.826,0.672 l-1.021,0.543c0,0-1.553,0.42-1.512,0.881c0.035,0.377,1.592-0.318,2.513-0.592c0.056,0.232,0.14,0.48,0.244,0.719l-0.501,0.268 c0,0-1.554,0.42-1.512,0.881c0.032,0.354,1.42-0.244,2.35-0.543c0.032,0.047,0.064,0.09,0.099,0.131 c-0.268,0.107-1.259,0.525-1.194,0.875c0.053,0.279,1.042-0.127,1.812-0.482c0.202-0.023,0.476-0.166,0.775-0.369 c0.007-0.004,0.014-0.006,0.021-0.01c0.669-0.316,1.097-0.875,1.097-0.875l-0.005-0.01 C122.877,82.309,123.378,81.786,123.378,81.786z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#06065C",
    points: "97.053,99.129 94.457,98.233 96.952,99.868  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#06065C",
    d: "M100.431,97.864l-0.104-0.01c0.279-2.873,1.479-3.623,1.529-3.652l0.054,0.088 C101.897,94.297,100.704,95.049,100.431,97.864z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#06065C",
    points: "107.067,98.651 104.954,99.049 107.124,99.133  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M106.367,67.903c-0.397,0-0.398,0.619,0,0.619C106.765,68.522,106.766,67.903,106.367,67.903z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M108.771,69.889c-0.398,0-0.398,0.618,0,0.618C109.168,70.507,109.169,69.889,108.771,69.889z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M112.114,67.485c-0.398,0-0.398,0.619,0,0.619C112.511,68.104,112.513,67.485,112.114,67.485z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M114.935,70.098c-0.398,0-0.398,0.618,0,0.618C115.332,70.716,115.333,70.098,114.935,70.098z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M118.069,70.098c-0.398,0-0.398,0.618,0,0.618C118.467,70.716,118.468,70.098,118.069,70.098z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M116.606,65.919c-0.398,0-0.398,0.617,0,0.617C117.004,66.536,117.005,65.919,116.606,65.919z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M117.651,61.53c-0.398,0-0.398,0.618,0,0.618C118.049,62.148,118.05,61.53,117.651,61.53z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M107.308,64.038c-0.397,0-0.398,0.618,0,0.618S107.706,64.038,107.308,64.038z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M107.83,74.381c-0.397,0-0.398,0.617,0,0.617C108.228,74.999,108.229,74.381,107.83,74.381z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M111.487,74.067c-0.398,0-0.398,0.619,0,0.619C111.884,74.686,111.886,74.067,111.487,74.067z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M117.86,75.321c-0.398,0-0.398,0.619,0,0.619C118.258,75.94,118.259,75.321,117.86,75.321z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M118.278,77.934c-0.398,0-0.398,0.617,0,0.617C118.676,78.551,118.677,77.934,118.278,77.934z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M114.308,75.948c-0.397,0-0.398,0.619,0,0.619S114.706,75.948,114.308,75.948z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M108.457,78.352c-0.397,0-0.398,0.617,0,0.617C108.854,78.969,108.855,78.352,108.457,78.352z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M114.099,79.397c-0.398,0-0.398,0.617,0,0.617S114.497,79.397,114.099,79.397z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M114.203,82.739c-0.397,0-0.398,0.619,0,0.619C114.601,83.358,114.602,82.739,114.203,82.739z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M109.188,82.321c-0.398,0-0.398,0.619,0,0.619C109.586,82.94,109.587,82.321,109.188,82.321z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M111.905,78.665c-0.398,0-0.398,0.619,0,0.619C112.303,79.284,112.304,78.665,111.905,78.665z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M107.617,42.151c-0.575,0.471-0.856,1.251-0.722,1.981c0.131,0.708,0.66,1.3,1.326,1.552 c0.186,0.07,0.266-0.228,0.082-0.297c-0.568-0.215-1-0.739-1.11-1.337c-0.115-0.627,0.155-1.282,0.642-1.681 C107.989,42.243,107.771,42.026,107.617,42.151L107.617,42.151z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#06065C",
    d: "M110.991,65.979c-0.938,0-1.695-0.613-2.149-1.744c-0.5-1.25,0.397-6.125,0.437-6.332l0.101,0.019 c-0.009,0.05-0.931,5.051-0.441,6.274c0.474,1.184,1.249,1.762,2.246,1.671c1.256-0.114,3.986-1.317,5.331-5.059l0.097,0.034 c-1.362,3.791-4.14,5.012-5.419,5.127C111.124,65.976,111.058,65.979,110.991,65.979z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#06065C",
    d: "M119.208,67.079c-1.084-1.084-0.059-7.451-0.015-7.721l0.101,0.017c-0.01,0.066-1.061,6.585-0.014,7.632 L119.208,67.079z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E54750",
    d: "M112.071,62.556c-0.312,0-0.578-0.098-0.795-0.293c-1.708-1.533-1.077-4.708-1.05-4.843l0.302,0.062 c-0.006,0.031-0.621,3.136,0.953,4.552c0.279,0.25,0.686,0.279,1.21,0.087c2.04-0.749,4.964-4.438,5.105-5.482l0.306,0.042 c-0.17,1.25-3.259,4.979-5.305,5.731C112.533,62.508,112.29,62.556,112.071,62.556z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 115.183,
    y: 2.218,
    transform: "matrix(-0.6987 0.7154 -0.7154 -0.6987 206.2691 -58.1896)",
    fill: "#E54750",
    width: 0.41,
    height: 24.243
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114.712,
    y: 5.697,
    transform: "matrix(-0.6975 0.7166 -0.7166 -0.6975 207.8379 -52.1024)",
    fill: "#E54750",
    width: 0.409,
    height: 24.243
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114.24,
    y: 9.175,
    transform: "matrix(-0.6987 0.7154 -0.7154 -0.6987 209.6442 -45.6979)",
    fill: "#E54750",
    width: 0.41,
    height: 24.242
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "#DDA253",
    cx: 16.111,
    cy: 43.088,
    r: 6.016
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#06065C",
    d: "M16.928,50.319c-2.839,2.045-6.812,1.399-8.857-1.44s-1.398-6.813,1.441-8.858s6.812-1.398,8.857,1.441 S19.767,48.275,16.928,50.319z M9.896,40.556c-2.544,1.833-3.124,5.394-1.291,7.938s5.393,3.124,7.938,1.292 c2.545-1.833,3.124-5.394,1.292-7.938S12.441,38.723,9.896,40.556z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDA253",
    cx: 2.717,
    cy: 52.611,
    r: 2.717
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDA253",
    cx: 24.706,
    cy: 36.775,
    r: 2.717
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHow3);
export default __webpack_public_path__ + "static/media/how_3.ea774d867276e68a4b0c5fe4201e52e4.svg";
export { ForwardRef as ReactComponent };